/* eslint-disable @angular-eslint/prefer-standalone */
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DSM34Dialog, Dsm34UploadErrorList } from '@eredes/dsm34';

import { DialogAlertComponent } from 'app/_shared/modals/dialog-alert/dialog-alert.component';
import { IAttachment } from 'app/request-form/_models/attachment.interface';
import { RequestStateViewModel } from 'app/request-form/_models/request-state.view-model';

@Component({
  selector: 'app-request-state',
  templateUrl: './request-state.component.html',
  styleUrls: ['./request-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RequestStateComponent {
  @Input() viewModel: RequestStateViewModel;
  @Input() validForm: boolean;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit = new EventEmitter<any>();
  @Output() clickItem = new EventEmitter<IAttachment>();
  @Output() clickBack = new EventEmitter<IAttachment>();

  fileTypes: string[] = ['pdf', 'jpg', 'jpeg', 'png', 'xlsx', 'csv', 'doc', 'docx', 'sgl', 'sgl_v2', 'zip'];

  private readonly _dsm34Dialog = inject(DSM34Dialog);

  /**
   * Method called when clicking submit button
   */
  submitAction(): void {
    this.submit.emit();
  }

  /**
   * Show upload errors in a modal
   * @param {Dsm34UploadErrorList} errors - Dsm34UploadErrorList
   */
  showErrors(errors: Dsm34UploadErrorList): void {
    this._dsm34Dialog.open(DialogAlertComponent, {
      data: {
        properties: {
          icon: 'alerta',
          title: 'Ups! Ocorreu um problema...',
          message: errors.errorList
            .map((error) => {
              return `${error.file} - Erro: ${error.error === 'size' ? 'Tamanho excedido' : 'Tipo de ficheiro inválido'}`;
            })
            .join('. '),
        },
      },
    });
  }

  /**
   * Method called when attachment is clicked to download
   * @param {IAttachment} attachment attachment clicked from attachment list
   */
  downloadAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }

  /**
   * Action when back button is clicked
   */
  back(): void {
    this.clickBack.emit();
  }
}
